<script setup lang="ts">
withDefaults(
  defineProps<{
    loading?: boolean;
    disabled?: boolean;
    block?: boolean;
    outlined?: boolean;
    rounded?: boolean | string | number;
    size?: 'small' | 'default';
    type?: 'submit' | 'button';
    variant?: 'text' | 'outlined' | 'tonal' | 'flat' | 'plain';
    icon?: string;
    color?: string;
  }>(),
  {
    loading: false,
    disabled: false,
    block: false,
    outlined: false,
    rounded: 'xl',
    size: 'default',
    type: 'submit',
    variant: 'tonal',
    icon: undefined,
    color: 'primary',
  }
);
</script>
<template>
  <v-btn
    :color="color"
    data-cy="submit"
    data-testid="button"
    :type="type"
    :loading="loading"
    :disabled="disabled"
    :size="size"
    :variant="variant"
    :block="block"
    :rounded="rounded"
    class="app-base-button"
  >
    <template #default>
      <slot>
        <v-icon v-if="icon">{{ icon }}</v-icon>
      </slot>
    </template>

    <template #append>
      <slot name="append" />
    </template>
    <template #prepend>
      <slot name="prepend" />
    </template>
  </v-btn>
</template>

<style></style>
